import React from 'react';

import CommunicationMethods from './CommunicationMethods';
import Savings from './Savings';

export default props => {
  const { data } = props;
  if (
    data.messageCommunication ||
    data.emailCommunication ||
    data.videoCommunication ||
    data.cellCommunication ||
    data.homeVisits ||
    data.dispensing ||
    data.labDiscounts ||
    data.radiologyDiscounts
  ) {
    return (
      <div className="section">
        <h3 className="sectiontitle">Benefits of membership</h3>
        <br />
        <div className="sectionitem">
          <CommunicationMethods p={data} />
        </div>
        <br />
        <div className="sectionitem">
          <Savings p={data} />
        </div>
      </div>
    );
  }
  return null;
};
